module.exports = __webpack_public_path__ + "img/For-the-Future.78470117.png";